import { apiClient } from '../../config/axios.config';
import { BASE_OVERTIME_URL, BASE_URL } from '../apiConfig';

const fetchEmployeeOvertime = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_OVERTIME_URL}/enquiry`,
    payload,
  );
  return response;
};

const applyOvertime = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_OVERTIME_URL}/apply`,
    payload,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return response;
};

const fetchOvertimeByTransactionId = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_OVERTIME_URL}/trans`,
    payload,
  );
  return response;
};

const fetchOvertimeDetails = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_OVERTIME_URL}`,
    payload,
  );
  return response;
};

export {
  fetchEmployeeOvertime,
  applyOvertime,
  fetchOvertimeByTransactionId,
  fetchOvertimeDetails,
};
